import React from "react";

const brl = (cents) =>
  (Number(cents || 0) / 100).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

export default function ReconciliationDetailsModal({ data, onClose }) {
  return (
    <div className="afxp-modal-backdrop" onMouseDown={onClose}>
      <section
        className="afxp-modal"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header>
          <div>
            <small>CONCILIACAO ASAAS</small>
            <h2>Detalhes da execucao</h2>
          </div>
          <button onClick={onClose}>x</button>
        </header>
        <div className="afxp-review-grid">
          <span>
            Fluxopay<b>{brl(data.run.internal_total_cents)}</b>
          </span>
          <span>
            Asaas<b>{brl(data.run.provider_total_cents)}</b>
          </span>
          <span>
            Diferenca<b>{brl(data.run.difference_cents)}</b>
          </span>
          <span>
            Status<b>{data.run.status}</b>
          </span>
        </div>
        <h3>Cobrancas verificadas</h3>
        {data.orders.length === 0 ? (
          <p>Nenhuma cobranca entrou nesta execucao.</p>
        ) : (
          data.orders.map((order) => (
            <div className="afxp-provider-fee" key={order.id}>
              <div>
                <b>{order.external_id}</b>
                <small>
                  {order.account?.entidade?.nome ||
                    `Entidade #${order.entidade_id}`}{" "}
                  - {order.provider_financial_status || order.status}
                </small>
              </div>
              <strong>
                {brl(order.gross_amount_cents)} - taxa{" "}
                {brl(order.provider_fee_cents)} - liquido{" "}
                {brl(order.clinic_net_cents)}
              </strong>
            </div>
          ))
        )}
        {data.errors.length > 0 && (
          <>
            <h3>Erros por subconta</h3>
            {data.errors.map((error, index) => (
              <p className="afxp-warning" key={index}>
                Conta #{error.account_id}: {error.message}
              </p>
            ))}
          </>
        )}
        <footer>
          <button className="afxp-primary" onClick={onClose}>
            Fechar
          </button>
        </footer>
      </section>
    </div>
  );
}
